import React, { useEffect, useState } from 'react';
import {
    Input,
    Col,
    Row,
    FormFeedback,
} from 'reactstrap';
import Select from 'react-select';
import { useDispatch } from 'react-redux';
import { getAllPartiesCustomerData } from '../../../../store/Parties/Customer/action';
import { useSelector } from 'react-redux';
import ModalAddNewCustomer from '../../../Parties/Modal/ModalAddNewCustomer';
import {UPDATE_SEARCH_INSTANT_RATE_DATA, UPDATE_VALUE_BLANK} from "../../../../store/InstantRate/actionType";


const CustomerDetails = ({ customerDetailsFormik , locationFrom }) => {
    const dispatch = useDispatch();
    const [addNewCustomerModal, setAddNewCustomerModal] = useState(false);
    const { customer_data } = useSelector((state) => state?.customer);
    const [customerInfo, setCustomerInfo] = useState({});

    const onCloseClick = () => {
        setAddNewCustomerModal(false);
    }

    useEffect(() => {
        dispatch(getAllPartiesCustomerData(""));
        // Attach click event when no options are shown
        const handleClick = (event) => {
            if (event.target.classList.contains("custom-no-options")) {
                setAddNewCustomerModal(true);
            }
        };

        document.addEventListener("click", handleClick);
        return () => document.removeEventListener("click", handleClick);
    }, []);


    const customerNameLists = customer_data?.content?.length > 0
        ? [...(customer_data?.content?.map(customer => ({
            key: customer.id,
            value: customer.id.toString(),
            label: customer.name,
            version: customer.version,
            address: customer?.address,
            city: customer?.city,
            pinCode: customer?.pinCode,
            country: customer?.country,
            state: customer?.state,
            contactName: customer?.contactName,
            contactEmail: customer?.contactEmail,
            contactNo: customer?.contactNo,
        })) || []),
        {
            value: "addnew",
            label: "Add New Customer",
            version: "0"
        }] : [{ value: "addnew", label: "Add New Customer", version: "0" }];

    const handleChangeHandler = (item, name, blank, blank_name) => {
        if (blank) {
            dispatch({ type: UPDATE_VALUE_BLANK, payload: blank_name })
        }
        dispatch({ type: UPDATE_SEARCH_INSTANT_RATE_DATA, payload: { item, name } });
    }

    return (
        <>
            <div className='charges_wrap'>
                <Row>
                    <Col md={6}>
                        <div className="mb-3">
                            <label className="form-label">Customer Name<span
                                className='required_star'>*</span></label>
                            <div className='field_wrap'>
                                <Select
                                    id='customerName'
                                    name='customerName'
                                    value={locationFrom === 'addMargin' ? customerInfo.customerName : customerDetailsFormik.values.customerName}
                                    onChange={(e) => {
                                        if (e.value === 'addnew') {
                                            setAddNewCustomerModal(true);
                                            customerDetailsFormik.setFieldValue('customerAddress', '');
                                            customerDetailsFormik.setFieldValue('contactName', '');
                                            customerDetailsFormik.setFieldValue('contactEmail', '');
                                            customerDetailsFormik.setFieldValue('contactNumber', '');
                                            customerDetailsFormik.setFieldValue('customerName', '');
                                        } else {
                                            const customerAddress =
                                                (e?.address || '') + ' ' +
                                                (e?.city?.cityName || '') + ' ' +
                                                (e?.state?.stateName || '') + ' ' +
                                                (e?.pinCode?.pin || '') + ' ' +
                                                (e?.country?.countryName || '');
                                            if (locationFrom === 'addMargin') {
                                                //console.log(e, "customerName");
                                                handleChangeHandler({value : e?.value, label: e?.label, customerAddress: customerAddress, version: e?.version }, "customerName");
                                                setCustomerInfo({
                                                    'customerAddress': customerAddress,
                                                    'contactName': e?.contactName || '',
                                                    'contactEmail': e?.contactEmail || '',
                                                    'contactNumber': e?.contactNo || '',
                                                    'customerName': e
                                                });
                                            } else {
                                                customerDetailsFormik.setFieldValue('customerAddress', customerAddress);
                                                customerDetailsFormik.setFieldValue('contactName', e?.contactName || '');
                                                customerDetailsFormik.setFieldValue('contactEmail', e?.contactEmail || '');
                                                customerDetailsFormik.setFieldValue('contactNumber', e?.contactNo || '');
                                                customerDetailsFormik.setFieldValue('customerName', e);
                                            }
                                        }
                                    }}
                                    placeholder="Select Customer"
                                    options={customerNameLists}
                                    classNamePrefix="form-select"
                                    onBlur={
                                        locationFrom === 'addMargin'
                                            ? undefined
                                            : customerDetailsFormik.handleBlur
                                    }
                                    invalid={
                                        locationFrom === 'addMargin'
                                            ? undefined
                                            : customerDetailsFormik.touched.customerName &&
                                            !!customerDetailsFormik.errors.customerName
                                    }
                                    styles={{
                                        control: (baseStyles) => {
                                            let borderColor = baseStyles.borderColor;

                                            if (locationFrom !== 'addMargin') {
                                                borderColor = customerDetailsFormik.errors.customerName ? 'red' : 'grey';
                                            }

                                            return {
                                                ...baseStyles,
                                                borderColor,
                                            };
                                        },
                                    }}
                                />
                                {locationFrom !== 'addMargin' && (<FormFeedback>{customerDetailsFormik.errors.customerName}</FormFeedback>)}
                            </div>
                        </div>

                        <div className="mb-3">
                            <label className="form-label">Customer Address</label>
                            <Input
                                type="textarea"
                                id="customerAddress"
                                name="customerAddress"
                                rows="4"
                                placeholder="Enter Customer Address..."
                                value={locationFrom === 'addMargin' ? customerInfo?.customerAddress : customerDetailsFormik.values.customerAddress}
                                onChange={locationFrom === 'addMargin' ? undefined : customerDetailsFormik.handleChange}
                                onBlur={locationFrom === 'addMargin' ? undefined : customerDetailsFormik.handleBlur}
                                invalid={locationFrom === 'addMargin' ? undefined : customerDetailsFormik.touched.customerAddress && !!customerDetailsFormik.errors.customerAddress}
                            />
                            {locationFrom !== 'addMargin' && (<FormFeedback>{customerDetailsFormik.errors.customerAddress}</FormFeedback>)}
                        </div>
                    </Col>

                    <Col md={6}>
                        <div className="mb-3">
                            <label className="form-label">Contact Name</label>
                            <Input
                                id="contactName"
                                name="contactName"
                                placeholder="Enter Contact Name..."
                                value={locationFrom === 'addMargin' ? customerInfo?.contactName : customerDetailsFormik.values.contactName}
                                onChange={locationFrom === 'addMargin' ? undefined : customerDetailsFormik.handleChange}
                                onBlur={locationFrom === 'addMargin' ? undefined : customerDetailsFormik.handleBlur}
                                invalid={locationFrom === 'addMargin' ? undefined : customerDetailsFormik.touched.contactName && !!customerDetailsFormik.errors.contactName}
                            />
                            {locationFrom !== 'addMargin' && (<FormFeedback>{customerDetailsFormik.errors.contactName}</FormFeedback>)}
                        </div>

                        <div className="mb-3">
                            <label className="form-label">Contact Email</label>
                            <Input
                                type="email"
                                id="contactEmail"
                                name="contactEmail"
                                placeholder="Enter Contact Email..."
                                value={locationFrom === 'addMargin' ? customerInfo?.contactEmail : customerDetailsFormik.values.contactEmail}
                                onChange={locationFrom === 'addMargin' ? undefined : customerDetailsFormik.handleChange}
                                onBlur={locationFrom === 'addMargin' ? undefined : customerDetailsFormik.handleBlur}
                                invalid={locationFrom === 'addMargin' ? undefined : customerDetailsFormik.touched.contactEmail && !!customerDetailsFormik.errors.contactEmail}
                            />
                            {locationFrom !== 'addMargin' && (<FormFeedback>{customerDetailsFormik.errors.contactEmail}</FormFeedback>)}
                        </div>

                        <div className="mb-3">
                            <label className="form-label">Contact Number</label>
                            <Input
                                id="contactNumber"
                                name="contactNumber"
                                type="number"
                                pattern="\d*"
                                minLength={10}
                                maxLength={10}
                                placeholder="Enter Contact Number..."
                                value={locationFrom === 'addMargin' ? customerInfo?.contactNumber : customerDetailsFormik.values.contactNumber}
                                onChange={locationFrom === 'addMargin' ? undefined : customerDetailsFormik.handleChange}
                                onBlur={locationFrom === 'addMargin' ? undefined : customerDetailsFormik.handleBlur}
                                invalid={locationFrom === 'addMargin' ? undefined : customerDetailsFormik.touched.contactNumber && !!customerDetailsFormik.errors.contactNumber}
                            />
                            {locationFrom !== 'addMargin' && (<FormFeedback>{customerDetailsFormik.errors.contactNumber}</FormFeedback>)}

                            {/*<Row>*/}
                            {/*    <Col xs="4">*/}
                            {/*        <Input*/}
                            {/*            id="contactNumber1"*/}
                            {/*            name="contactNumber1"*/}
                            {/*            value={customerDetailsFormik.values.contactNumber1}*/}
                            {/*            onChange={customerDetailsFormik.handleChange}*/}
                            {/*            onBlur={customerDetailsFormik.handleBlur}*/}
                            {/*            invalid={customerDetailsFormik.touched.contactNumber1 && !!customerDetailsFormik.errors.contactNumber1}*/}
                            {/*        />*/}
                            {/*        <FormFeedback>{customerDetailsFormik.errors.contactNumber1}</FormFeedback>*/}
                            {/*    </Col>*/}
                            {/*    <Col xs="8">*/}
                            {/*        */}
                            {/*    </Col>*/}
                            {/*</Row>*/}
                        </div>
                    </Col>
                </Row>
                {/*<button*/}
                {/*    type="button"*/}
                {/*    className="btn btn-primary mt-3"*/}
                {/*    onClick={customerDetailsFormik.handleSubmit}>*/}
                {/*    Submit*/}
                {/*</button>*/}
            </div>
            <ModalAddNewCustomer modal={addNewCustomerModal} onCloseClick={onCloseClick} />
        </>
    );
};

export default CustomerDetails;
